import useGetPipeline from '@/api/queries/pipelines/useGetPipeline';

const useGetPipelineStage = (args: {
  pipelinePublicId?: string;
  pipelineStagePublicId?: string;
}) => {
  const { pipeline, ...rest } = useGetPipeline(args.pipelinePublicId);

  const pipelineStage = pipeline?.stages.find(
    (stage) => stage.publicId === args.pipelineStagePublicId
  );

  return {
    pipeline,
    pipelineStage,
    ...rest,
  };
};

export default useGetPipelineStage;
